<template>
  <div itemscope itemtype="https://schema.org/VideoGame">
    <h1 itemprop="name">{{ title || this.post.title }}</h1>

    <article class="card-deck" id="top-rom" v-if="this.post.title">
      <div>
        <section class="card">
          <img
            itemprop="screenshot"
            class="thumb"
            v-if="image1 || this.post.image1"
            :src="image1 || this.post.image1"
            :alt="title || this.post.title"
          />
        </section>
      </div>

      <div>
        <section class="card">
          <img
            itemprop="screenshot"
            class="thumb"
            v-if="image2 || this.post.image2"
            :src="image2 || this.post.image2"
            :alt="title || this.post.title"
          />
        </section>
      </div>

      <aside class="download-block">
        <h2 itemprop="description" v-html="this.post.itempropDescription"></h2>
        <h3>
          <span class="float-left" itemprop="alternateName" v-if="this.post.rom"
            >File: <em>{{ this.post.rom }}</em></span
          >
          <span class="float-right" itemprop="fileSize" v-if="this.post.size"
            >Size: <em>{{ this.post.size }}</em></span
          >
        </h3>

        <Download :slug="slug || this.post.slug" />
        <Share
          :social="['facebook', 'twitter']"
          :title="title || this.post.title"
          :description="this.post.description"
        />
      </aside>

      <div class="hr"></div>
    </article>
    <RandomList v-if="this.post.title" />
  </div>
</template>

<script>
import api from "@/api";
import Download from "@/components/Download";
import Share from "@/components/Share";
import RandomList from "@/components/RandomList";

export default {
  name: "Rom",
  props: ["slug", "image1", "image2", "title"],
  metaInfo() {
    if (window.location.href.split("/")[3] != "rom") {
      return;
    }
    return {
      // title: this.title || this.post.title,
      title: this.post.title || this.title,
      titleTemplate: "%s | Fightcade ROMs",
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: window.location.toString().includes("//www.")
            ? window.location.replace(url.replace("www.", ""))
            : window.location.href,
        },
      ],
      meta: [
        { charset: "utf-8" },
        {
          vmid: "description",
          name: "description",
          content: this.post.description
            ? this.post.description
            : `Download the rom ${this.post.title} for FightCade.`,
        },
        {
          vmid: "keywords",
          name: "keywords",
          itemprop: "keywords",
          content: this.post.keywords
            ? `${this.post.keywords}, rom, fightcade roms`
            : `rom, fightcade roms, ${this.post.title}`,
        },
        {
          vmid: "robots",
          name: "robots",
          content: window.location
            .toString()
            .includes("//www.") /*nao indexar url com www*/
            ? "noindex, nofollow"
            : "all, index, follow, archive",
        },
        /**Facebook */
        {
          vmid: "og:title",
          property: "og:title",
          content: `${this.title || this.post.title} | Fightcade ROMs`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.post.description
            ? this.post.description
            : `Download the rom ${this.post.title} for FightCade.`,
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: window.location.href,
        },
        {
          vmid: "og:site_name",
          property: "og:site_name",
          content: "fightcaderoms.com",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "website",
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: this.post.url_image,
        },
        /**Twitter */
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: this.title || this.post.title,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.post.description
            ? this.post.description
            : `Download the rom ${this.post.title} for FightCade.`,
        },
        {
          vmid: "twitter:site",
          name: "twitter:site",
          content: window.location.href,
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: "summary",
        },
        {
          vmid: "twitter:image:src",
          name: "twitter:image:src",
          content: this.post.url_image,
        },
      ],
    };
  },
  components: {
    Download,
    Share,
    RandomList,
  },
  data() {
    return {
      post: {},
    };
  },

  created() {
    this.getResults(this.slug);
  },

  watch: {
    $route: function (to, from) {
      this.getResults(this.$route.params.slug);
      // this.$router.go(this.$router.currentRoute);
    },
  },

  methods: {
    getResults(slug) {
      if (slug)
        api.get(`post/${slug}`).then((response) => {
          this.post = response.data;

          //se nao encontrar o conteudo redireciona para pagina de 404
          if (!response.data.title) {
            document.location.href = "/page-not-found";
          }

          //trata o texto da descricao para ebibir props do schema org
          this.post.itempropDescription = this.post.description
            .replace(
              "rom",
              '<span itemprop="applicationCategory" content="GameApplication">rom</span>'
            )
            .replace(
              "FightCade",
              '<span itemprop="gamePlatform">FightCade</span>'
            );

          if (document.getElementsByTagName("header")[0]) {
            document.getElementsByTagName("header")[0].scrollIntoView();
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Rom.vue